/* Pending:
Required Backend Endpoints

You will need:

1) GET waiver by ID
GET /business_waiver_builder/waiver_master/:id

2) PATCH step 3
PATCH /business_waiver_builder/waiver_master/smart_step2/:id
*/

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import API_URL from "../../api/API";
import WaiverStepLayout from "./WaiverStepLayout";
import WAIVER_STEP_RULES from "./WaiverStepConfig";

const BusinessSmartTemplateStep3 = () => {
  const { business } = useBusinessAuthContext();
  const navigate = useNavigate();
  const { waiverId } = useParams();

  const [minorWaiverAllowed, setMinorWaiverAllowed] = useState(null);
  const [loading, setLoading] = useState(true);

  const [waiver, setWaiver] = useState(null); 
  const stepRules = WAIVER_STEP_RULES["step3"] || {};
  const statusRule = stepRules[waiver?.waiverStatus] || {};
  const isReadOnly = statusRule.readOnly ?? false;
  const readOnlyReason = statusRule.reason ?? "";

  const [saving, setSaving] = useState(false);

  // Load existing waiver data
  useEffect(() => {
    if (!business) {
      navigate("/business/login");
      return;
    }

    const fetchWaiver = async () => {
      try {
        const res = await fetch(
          `${API_URL.BUSINESS_WAIVER_BY_ID}/${waiverId}`,
          {
            headers: {
              Authorization: `Bearer ${business.token}`,
              "x-session-id": business.sessionId,               
              "x-frontend-url": window.location.pathname  
            },
          }
        );

        const data = await res.json();

        if (data.success) {
          setMinorWaiverAllowed(data.waiver.minorWaiverAllowed ?? null);
          setWaiver(data.waiver);
        }
      } catch (err) {
        console.error("Failed to load waiver", err);
      } finally {
        setLoading(false);
      }
    };

    fetchWaiver();
  }, [business, waiverId, navigate]);

  const handleContinue = async () => {

    if (minorWaiverAllowed === null) return;
    if (saving) return;
    setSaving(true);

    try {
      const res = await fetch(
        `${API_URL.BUSINESS_WAIVER_SMART_STEP_MINOR_PERMISSION}/${waiverId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${business.token}`,
            "x-session-id": business.sessionId,             
            "x-frontend-url": window.location.pathname  
          },
          body: JSON.stringify({
            minorWaiverAllowed,
          }),
        }
      );

      const data = await res.json();

      if (data.success) {
        navigate(
          `/business/waiverbuilder/smart/${waiverId}/step-4`
        );
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error("Failed to save step 3", err);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <>
    {/* <div className="h-screen flex bg-background">
      <Sidebar />

      <div className="flex-1 overflow-auto py-10">  */ }
      <WaiverStepLayout  waiver={waiver} currentStep="step-3"  isReadOnly={isReadOnly} readOnlyReason={readOnlyReason} >
        <div className="max-w-3xl mx-auto px-6">
          
          <div className="flex items-center justify-between mb-6">
            {/* Back */}
            {waiver?.waiverStatus !== "new_version" && (
              <button
                onClick={() =>
                  navigate(`/business/waiverbuilder/smart/${waiverId}/step-2`)
                }
                className="text-sm text-muted-foreground"
              >
                ← Previous Step
              </button>
            )}

            {/* Next (only when readOnly) */}
            {isReadOnly && (
              <button
                onClick={() =>
                  navigate(`/business/waiverbuilder/smart/${waiverId}/step-4`)
                }
                className="text-sm text-muted-foreground"
              >
                Next Step →
              </button>
            )}
          </div>

          <h1 className="text-2xl font-semibold mb-1">
            Eligibility Builder
          </h1>
          <p className="text-sm text-muted-foreground mb-8">
            Step 3 of 7 · Configure screening requirements
          </p>

          <div className="bg-white rounded-xl shadow-sm p-8">
            <h2 className="text-lg font-semibold mb-1">
              Minors
            </h2>
            <p className="text-sm text-muted-foreground mb-6">
              Set age rules for signers
            </p>

            {/* Allow Minors */}
            <div
              onClick={() => {
                if (!isReadOnly) {
                  setMinorWaiverAllowed(true);
                }
              }}
              className={`border rounded-lg p-4 mb-4 ${
                isReadOnly ? "cursor-not-allowed opacity-60" : "cursor-pointer"
              } ${
                minorWaiverAllowed === true
                  ? "border-yellow-500 bg-yellow-50"
                  : "border-gray-200"
              }`}
            >
              <div className="font-medium">
                Allow minors
              </div>
              <div className="text-sm text-muted-foreground">
                Under 18 may sign with guardian consent and co-signature
              </div>
            </div>

            {/* Block Minors */}
            <div
              onClick={() => {
                if (!isReadOnly) {
                  setMinorWaiverAllowed(false);
                }
              }}
              className={`border rounded-lg p-4 ${
                isReadOnly ? "cursor-not-allowed opacity-60" : "cursor-pointer"
              } ${
                minorWaiverAllowed === false
                  ? "border-yellow-500 bg-yellow-50"
                  : "border-gray-200"
              }`}
            >
              <div className="font-medium">
                Block minors
              </div>
              <div className="text-sm text-muted-foreground">
                Under 18 signers are automatically blocked
              </div>
            </div>

            {!isReadOnly && ( 
            <div className="flex justify-end mt-8">
              <button
                disabled={minorWaiverAllowed === null || saving}
                onClick={handleContinue}
                className={`px-6 py-3 rounded-full font-medium ${
                  minorWaiverAllowed !== null && !saving
                    ? "bg-yellow-500 hover:bg-yellow-600 text-black"
                    : "bg-yellow-100 text-yellow-400 cursor-not-allowed"
                }`}
              >
                {saving ? "Saving..." : "Continue →"}
              </button>
            </div>
            )}

          </div>
        </div>
      </WaiverStepLayout>  
      {  /* </div>
    </div> */ }
    </>
  );
};

export default BusinessSmartTemplateStep3;